<template>
    <BlogLayout v-bind="blogSharedData.getBlogLayoutProps()">
        <section class="max-w-7xl mx-auto px-6 pt-12 pb-20">
            <BlogHomeHero />

            <BlogFeaturedPost
                v-if="featuredPost"
                :post="featuredPost"
                class="mt-14"
            />

            <BlogPostGrid
                class="mt-16"
                :posts="posts"
            />
        </section>
    </BlogLayout>
</template>

<script setup lang="ts">
    import CMSArticle from '@/CMS/Content/Entity/CMSArticle'
    import BlogFeaturedPost from '@/Marketing/Blog/Component/BlogFeaturedPost.vue'
    import BlogHomeHero from '@/Marketing/Blog/Component/BlogHomeHero.vue'
    import BlogPostGrid from '@/Marketing/Blog/Component/BlogPostGrid.vue'
    import BlogSharedData from '@/Marketing/Blog/Entity/BlogSharedData'
    import BlogLayout from '@/Marketing/Blog/Shared/BlogLayout.vue'
    import type {
        CMSArticleRawData,
        BlogSharedDataRawData,
    } from '@/Shared/AutoGenerated/Main'

    interface BlogShowHomeProps {
        blogSharedDataRawData: BlogSharedDataRawData
        postsRawData: CMSArticleRawData[]
        featuredPostRawData: CMSArticleRawData | null
    }

    const props = defineProps<BlogShowHomeProps>()

    const blogSharedData = BlogSharedData.hydrate(props.blogSharedDataRawData)
    const featuredPost = CMSArticle.hydrateSingleOrNull(
        props.featuredPostRawData,
    )
    const posts = CMSArticle.hydrateMultiple(props.postsRawData)
</script>
